export default "__VITE_ASSET__$Yms40T9__"